import React from 'react';

const EmptyPage = () => {
  return (
    <div className="empty-page">
      <h1>Welcome to the Empty Page</h1>
      <p>This is a blank page for you to customize.</p>
    </div>
  );
};

export default EmptyPage;
